import {
    Drawer,
    DrawerProps,
    ScrollArea
} from '@mantine/core';
import {FilterForm} from '../forms/FilterForm/FilterForm';

export const FilterDrawer = ({
                                 opened,
                                 onClose,
                                 ...rest
                             }: DrawerProps) => {
    return (
        <Drawer
            transitionProps={{
                transition: 'slide-left',
                duration: 750,
                timingFunction: 'ease'
            }}
            position="right"
            offset={10}
            opened={opened}
            onClose={onClose}
            title="Filter Usage Events"
            padding="xl"
            size="md"
            scrollAreaComponent={ScrollArea.Autosize}
            {...rest}
        >
            <FilterForm
                onApply={() => onClose()}
                onCancel={onClose}
            />
        </Drawer>
    );
};
